(function () {
  var buyboxSyncByForm = new WeakMap();

  function initMediaSlider(root) {
    var sliderEl = root.querySelector('[data-mpb-media-slider]');
    if (!sliderEl) return;

    var slideCount = parseInt(sliderEl.getAttribute('data-mpb-media-count') || '0', 10);
    if (slideCount < 2) return;

    var mountSlider = function () {
      if (sliderEl.splide) {
        try {
          sliderEl.splide.destroy();
        } catch (e) { /* noop */ }
      }

      var splide = new Splide(sliderEl, {
        type: 'slide',
        rewind: true,
        perPage: 1,
        perMove: 1,
        gap: 0,
        padding: 0,
        arrows: false,
        pagination: true,
        mediaQuery: 'min',
        breakpoints: {
          990: {
            destroy: true
          }
        },
        classes: {
          pagination: 'splide__pagination flex pointer-events-none justify-center w-full pagination-dots mpb-v21__media-pagination',
          page: 'button none_border flex items-center pt-2 pb-2'
        }
      });

      splide.on('move', function () {
        sliderEl.querySelectorAll('video').forEach(function (video) {
          try {
            video.pause();
          } catch (e) { /* noop */ }
        });
      });

      splide.mount();
      sliderEl.splide = splide;
    };

    var loadSliderScript = function () {
      if (typeof window.Splide !== 'undefined') {
        mountSlider();
        return;
      }

      document.addEventListener('slider loaded', mountSlider, { once: true });

      if (!window.Eurus || !window.Eurus.sliderScript) return;
      if (window.Eurus.loadedScript && window.Eurus.loadedScript.has('slider')) return;

      window.Eurus.loadedScript.add('slider');
      var script = document.createElement('script');
      script.src = window.Eurus.sliderScript;
      script.defer = true;
      script.onload = function () {
        document.dispatchEvent(new CustomEvent('slider loaded'));
      };
      document.head.appendChild(script);
    };

    loadSliderScript();
  }

  function initBuyBox(root) {
    if (root.dataset.mpbInit) return;
    root.dataset.mpbInit = '1';

    initMediaSlider(root);

    var dataEl = root.querySelector('[data-bb-data]');
    var data = { variants: [] };
    if (dataEl) {
      try { data = JSON.parse(dataEl.textContent); } catch (e) { /* noop */ }
    }
    var variants = data.variants || [];

    var formEl = root.querySelector('.mpb-v21__form') || root.querySelector('form');

    function el(sel) {
      return root.querySelector(sel);
    }

    function getVariant(id) {
      id = String(id);
      return variants.find(function (v) { return String(v.id) === id; }) || variants[0];
    }
    function syncVariantRadiosFromCards() {
      var selectedCard = root.querySelector('.mpb-v21__vcard.is-selected');
      if (!selectedCard) return;
      var radio = selectedCard.querySelector('[data-bb-variant]');
      if (!radio || radio.disabled) return;
      radio.checked = true;
    }
    function selectedVariantInput() {
      syncVariantRadiosFromCards();
      return root.querySelector('[data-bb-variant]:checked')
        || root.querySelector('.mpb-v21__vcard.is-selected [data-bb-variant]');
    }
    function selectedVariantId() {
      var input = selectedVariantInput();
      if (input && input.value) return input.value;
      var idInput = el('[data-bb-id]');
      if (idInput && idInput.value) return idInput.value;
      return variants[0] && variants[0].id;
    }
    function isSubscribeSelected() {
      if (root.querySelector('[data-bb-purchase][value="subscribe"]:checked')) return true;
      var subCard = root.querySelector('[data-bb-pcard="subscribe"]');
      return Boolean(subCard && subCard.classList.contains('is-selected'));
    }
    function syncPurchaseRadiosFromCards() {
      var subCard = root.querySelector('[data-bb-pcard="subscribe"]');
      var onceCard = root.querySelector('[data-bb-pcard="onetime"]');
      var subRadio = root.querySelector('[data-bb-purchase][value="subscribe"]');
      var onceRadio = root.querySelector('[data-bb-purchase][value="onetime"]');
      if (!subRadio || !onceRadio) return;
      if (subCard && subCard.classList.contains('is-selected')) {
        subRadio.checked = true;
        onceRadio.checked = false;
        return;
      }
      if (onceCard && onceCard.classList.contains('is-selected')) {
        onceRadio.checked = true;
        subRadio.checked = false;
      }
    }
    function purchaseType() {
      syncPurchaseRadiosFromCards();
      var onceCard = root.querySelector('[data-bb-pcard="onetime"]');
      if (onceCard && onceCard.classList.contains('is-selected')) {
        return 'onetime';
      }
      if (isSubscribeSelected()) return 'subscribe';
      if (root.querySelector('[data-bb-frequency]')) return 'subscribe';
      var checked = root.querySelector('[data-bb-purchase]:checked');
      return checked ? checked.value : 'onetime';
    }
    function getAllocation(variant, freqSelect) {
      if (!variant || !variant.allocations || !variant.allocations.length) return null;
      var planId = freqSelect ? String(freqSelect.value) : null;
      if (planId) {
        var match = variant.allocations.find(function (a) { return String(a.id) === planId; });
        if (match) return match;
      }
      return variant.allocations[0];
    }

    function syncSellingPlan() {
      var planInput = el('[data-bb-plan]');
      var freqSelect = el('[data-bb-frequency]');
      if (!planInput) return '';
      var type = purchaseType();
      if (type !== 'subscribe') {
        planInput.value = '';
        planInput.removeAttribute('name');
        return '';
      }
      var variant = getVariant(selectedVariantId());
      var alloc = getAllocation(variant, freqSelect);
      var planId = alloc ? String(alloc.id) : (freqSelect ? String(freqSelect.value) : '');
      planInput.value = planId;
      if (planId) {
        planInput.setAttribute('name', 'selling_plan');
      } else {
        planInput.removeAttribute('name');
      }
      return planId;
    }

    function setText(sel, txt) {
      root.querySelectorAll(sel).forEach(function (el) { el.textContent = txt; });
    }
    function show(el, visible) {
      if (!el) return;
      if (visible) { el.removeAttribute('hidden'); el.style.display = ''; }
      else { el.setAttribute('hidden', ''); el.style.display = 'none'; }
    }

    function recompute() {
      syncPurchaseRadiosFromCards();
      var idInput = el('[data-bb-id]');
      var freqSelect = el('[data-bb-frequency]');
      var variant = getVariant(selectedVariantId());
      if (!variant) return;
      var type = purchaseType();

      // Per-variant card prices for subscribe & one-time
      var alloc = getAllocation(variant, freqSelect);
      // One-time price display
      var onceCompareEl = root.querySelector('[data-bb-once-compare]');
      var oncePriceEl = root.querySelector('[data-bb-once-price]');
      if (oncePriceEl) oncePriceEl.textContent = variant.price_money;
      if (onceCompareEl) {
        if (variant.compare > variant.price) { onceCompareEl.textContent = variant.compare_money; show(onceCompareEl, true); }
        else show(onceCompareEl, false);
      }
      // Subscribe price display
      var subCompareEl = root.querySelector('[data-bb-sub-compare]');
      var subPriceEl = root.querySelector('[data-bb-sub-price]');
      if (subPriceEl) subPriceEl.textContent = alloc ? alloc.price_money : variant.price_money;
      if (subCompareEl) {
        if (alloc && alloc.has_compare) { subCompareEl.textContent = alloc.compare_money; show(subCompareEl, true); }
        else show(subCompareEl, false);
      }

      // Active price (main + button) based on purchase type
      var priceMoney, compareMoney, hasCompare, pct;
      if (type === 'subscribe' && alloc) {
        priceMoney = alloc.price_money;
        compareMoney = alloc.compare_money;
        hasCompare = alloc.has_compare;
        pct = alloc.pct;
      } else {
        priceMoney = variant.price_money;
        compareMoney = variant.compare_money;
        hasCompare = variant.compare > variant.price;
        pct = hasCompare ? Math.round((variant.compare - variant.price) / variant.compare * 100) : 0;
      }
      syncSellingPlan();

      if (idInput) idInput.value = String(variant.id);

      // Main price
      setText('[data-bb-price]', priceMoney);
      var compareEl = root.querySelector('[data-bb-compare]');
      if (compareEl) {
        if (hasCompare) { compareEl.textContent = compareMoney; show(compareEl, true); }
        else show(compareEl, false);
      }
      var saveEl = root.querySelector('[data-bb-save]');
      if (saveEl) {
        if (hasCompare && pct > 0) { setText('[data-bb-save-pct]', pct); show(saveEl, true); }
        else show(saveEl, false);
      }

      // ATC button
      setText('[data-bb-atc-price]', priceMoney);
      var atcCompare = root.querySelector('[data-bb-atc-compare]');
      if (atcCompare) {
        if (hasCompare) { atcCompare.textContent = compareMoney; show(atcCompare, true); }
        else show(atcCompare, false);
      }
    }

    // Variant selection
    root.querySelectorAll('[data-bb-variant]').forEach(function (input) {
      input.addEventListener('change', function () {
        root.querySelectorAll('[data-bb-vcard]').forEach(function (c) { c.classList.remove('is-selected'); });
        var card = input.closest('[data-bb-vcard]');
        if (card) card.classList.add('is-selected');
        recompute();
      });
    });

    // Purchase type
    root.querySelectorAll('[data-bb-purchase]').forEach(function (input) {
      input.addEventListener('change', function () {
        root.querySelectorAll('[data-bb-pcard]').forEach(function (c) { c.classList.remove('is-selected'); });
        var card = input.closest('[data-bb-pcard]');
        if (card) card.classList.add('is-selected');
        recompute();
      });
    });

    function prepareForAddToCart() {
      syncPurchaseRadiosFromCards();
      neutralizeAppstle();
      recompute();
      return syncSellingPlan();
    }

    if (formEl) {
      buyboxSyncByForm.set(formEl, prepareForAddToCart);
      formEl.addEventListener('submit', function (e) {
        e.preventDefault();
      });
    }

    // Neutralize the auto-injected Appstle widget's selling_plan inputs so they
    // are never submitted alongside our native selling_plan field. Runs in the
    // capture phase before the theme's add-to-cart handler builds FormData.
    function neutralizeAppstle() {
      var planInput = el('[data-bb-plan]');
      if (formEl) {
        formEl.querySelectorAll('[name="selling_plan"]').forEach(function (input) {
          if (input !== planInput) input.removeAttribute('name');
        });
      }
      root.querySelectorAll('.appstle_sub_widget [name], [id^="appstle_subscription_widget"] [name]').forEach(function (input) {
        if (input.name === 'selling_plan') { input.removeAttribute('name'); }
      });
      syncSellingPlan();
    }
    var atcBtn = root.querySelector('[data-bb-atc]');
    if (atcBtn) atcBtn.addEventListener('click', prepareForAddToCart, true);
    if (formEl) formEl.addEventListener('ng:before-add-to-cart', prepareForAddToCart);

    // Frequency
    root.querySelectorAll('[data-bb-frequency]').forEach(function (freqSelect) {
      freqSelect.addEventListener('change', recompute);
      freqSelect.addEventListener('click', function (e) { e.stopPropagation(); });
    });

    // Tabs
    root.querySelectorAll('[data-bb-tab]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = btn.getAttribute('data-bb-tab');
        root.querySelectorAll('[data-bb-tab]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        root.querySelectorAll('[data-bb-panel]').forEach(function (p) {
          var on = p.getAttribute('data-bb-panel') === idx;
          p.classList.toggle('is-active', on);
          if (on) {
            p.classList.remove('is-in');
            void p.offsetWidth;
            p.classList.add('is-in');
          }
        });
      });
    });

    // Countdown
    var cd = root.querySelector('[data-bb-countdown]');
    if (cd) {
      var cutoffHour = parseInt(cd.getAttribute('data-cutoff-hour'), 10);
      if (isNaN(cutoffHour)) cutoffHour = 24;
      var shipEl = cd.querySelector('[data-bb-ship-date]');
      var timerEl = cd.querySelector('[data-bb-timer]');

      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var now = new Date();
        var target = new Date(now);
        if (cutoffHour >= 24) {
          target.setHours(23, 59, 59, 0);
        } else {
          target.setHours(cutoffHour, 0, 0, 0);
          if (target <= now) target.setDate(target.getDate() + 1);
        }
        var diff = Math.max(0, Math.floor((target - now) / 1000));
        var h = Math.floor(diff / 3600);
        var m = Math.floor((diff % 3600) / 60);
        var s = diff % 60;
        if (timerEl) timerEl.textContent = h + 'hr ' + pad(m) + 'mins ' + pad(s) + 'sec';
        if (shipEl) {
          var ship = new Date(now);
          ship.setDate(ship.getDate() + 1);
          shipEl.textContent = ship.toLocaleDateString(undefined, { month: 'long', day: 'numeric' });
        }
      }
      tick();
      setInterval(tick, 1000);
    }

    recompute();
  }

  window.mpbV21ResolveCartLine = function (formEl) {
    if (!formEl) return null;
    var root = formEl.closest('.mpb-v21');
    if (!root) return null;

    if (typeof window.ngBuyBoxPrepareForAddToCart === 'function') {
      try {
        window.ngBuyBoxPrepareForAddToCart(formEl);
      } catch (e) { /* noop */ }
    }

    var onceCard = root.querySelector('[data-bb-pcard="onetime"]');
    var oneTimeSelected = Boolean(onceCard && onceCard.classList.contains('is-selected'));

    var variantRadio = root.querySelector('[data-bb-variant]:checked')
      || root.querySelector('.mpb-v21__vcard.is-selected [data-bb-variant]');
    var variantId = (variantRadio && variantRadio.value) || (root.querySelector('[data-bb-id]') && root.querySelector('[data-bb-id]').value);
    if (!variantId) return null;

    var qtyInput = formEl.querySelector('[name="quantity"]');
    var quantity = qtyInput ? Number(qtyInput.value) || 1 : 1;
    var line = { id: String(variantId), quantity: quantity };

    if (!oneTimeSelected) {
      var freq = root.querySelector('[data-bb-frequency]');
      var planInput = root.querySelector('[data-bb-plan]');
      var planId = String(
        (freq && freq.value) || (planInput && planInput.value) || root.getAttribute('data-mpb-default-selling-plan') || ''
      ).trim();
      if (planId) line.selling_plan = planId;
    }

    return line;
  };

  window.ngBuyBoxPrepareForAddToCart = function (formEl) {
    if (!formEl) return '';
    var root = formEl.closest('.mpb-v21');
    if (root && !root.dataset.mpbInit) {
      initBuyBox(root);
    }
    var prepare = buyboxSyncByForm.get(formEl);
    if (prepare) return prepare();
    return window.ngBuyBoxGetSellingPlan(formEl);
  };

  function buyboxSyncPurchaseRadios(root) {
    if (!root) return;
    var subCard = root.querySelector('[data-bb-pcard="subscribe"]');
    var onceCard = root.querySelector('[data-bb-pcard="onetime"]');
    var subRadio = root.querySelector('[data-bb-purchase][value="subscribe"]');
    var onceRadio = root.querySelector('[data-bb-purchase][value="onetime"]');
    if (!subRadio || !onceRadio) return;
    if (subCard && subCard.classList.contains('is-selected')) {
      subRadio.checked = true;
      onceRadio.checked = false;
      return;
    }
    if (onceCard && onceCard.classList.contains('is-selected')) {
      onceRadio.checked = true;
      subRadio.checked = false;
    }
  }

  function buyboxWantsOneTime(root) {
    if (!root) return false;
    var onceCard = root.querySelector('[data-bb-pcard="onetime"]');
    return Boolean(onceCard && onceCard.classList.contains('is-selected'));
  }

  function buyboxIsSubscribe(root) {
    if (!root) return false;
    if (buyboxWantsOneTime(root)) return false;
    buyboxSyncPurchaseRadios(root);
    if (root.querySelector('[data-bb-purchase][value="subscribe"]:checked')) return true;
    var subCard = root.querySelector('[data-bb-pcard="subscribe"]');
    if (subCard && subCard.classList.contains('is-selected')) return true;
    return Boolean(root.querySelector('[data-bb-frequency]'));
  }

  function buyboxResolvePlanId(root, formEl) {
    if (!root) return '';
    var planInput = root.querySelector('[data-bb-plan]');
    var freqSelect = root.querySelector('[data-bb-frequency]');
    if (planInput && String(planInput.value).trim() !== '') {
      return String(planInput.value).trim();
    }
    if (freqSelect && String(freqSelect.value).trim() !== '') {
      return String(freqSelect.value).trim();
    }
    var dataEl = root.querySelector('[data-bb-data]');
    if (!dataEl) return '';
    try {
      var data = JSON.parse(dataEl.textContent);
      var variants = data.variants || [];
      var checked = root.querySelector('[data-bb-variant]:checked')
        || root.querySelector('.mpb-v21__vcard.is-selected [data-bb-variant]');
      var vid = checked ? String(checked.value) : (variants[0] && String(variants[0].id));
      var variant = variants.find(function (v) { return String(v.id) === vid; }) || variants[0];
      if (variant && variant.allocations && variant.allocations.length) {
        var planId = freqSelect ? String(freqSelect.value) : '';
        var alloc = planId
          ? variant.allocations.find(function (a) { return String(a.id) === planId; })
          : null;
        return String((alloc || variant.allocations[0]).id);
      }
    } catch (e) { /* noop */ }
    return '';
  }

  window.ngBuyBoxBuildCartAddItem = function (formEl) {
    if (!formEl) return null;
    var root = formEl.closest('.mpb-v21');
    if (!root) return null;
    if (!root.dataset.mpbInit) {
      initBuyBox(root);
    }
    buyboxSyncPurchaseRadios(root);
    if (typeof window.ngBuyBoxPrepareForAddToCart === 'function') {
      window.ngBuyBoxPrepareForAddToCart(formEl);
    }

    var selectedVcard = root.querySelector('.mpb-v21__vcard.is-selected');
    if (selectedVcard) {
      var vRadio = selectedVcard.querySelector('[data-bb-variant]');
      if (vRadio && !vRadio.disabled) vRadio.checked = true;
    }

    var variantInput = root.querySelector('[data-bb-variant]:checked')
      || root.querySelector('.mpb-v21__vcard.is-selected [data-bb-variant]');
    var variantId = variantInput && variantInput.value;
    if (!variantId) {
      var idInput = root.querySelector('[data-bb-id]');
      variantId = idInput && idInput.value;
    }
    if (!variantId) return null;

    var qtyInput = formEl.querySelector('[name="quantity"]');
    var quantity = qtyInput ? Number(qtyInput.value) || 1 : 1;

    if (buyboxWantsOneTime(root)) {
      return { id: String(variantId), quantity: quantity };
    }

    var planId = buyboxResolvePlanId(root, formEl);
    if (!planId && typeof window.ngBuyBoxGetSellingPlan === 'function') {
      planId = String(window.ngBuyBoxGetSellingPlan(formEl) || '').trim();
    }
    if (!planId) {
      return { id: String(variantId), quantity: quantity };
    }

    return {
      id: String(variantId),
      quantity: quantity,
      selling_plan: planId
    };
  };

  window.ngBuyBoxGetSellingPlan = function (formEl) {
    if (!formEl) return '';
    var root = formEl.closest('.mpb-v21');
    if (!root) return '';
    if (buyboxWantsOneTime(root)) return '';
    return buyboxResolvePlanId(root, formEl);
  };

  window.ngBuyBoxResolveSellingPlan = function (formEl) {
    if (!formEl) return '';
    var planId = '';
    if (typeof window.ngBuyBoxPrepareForAddToCart === 'function') {
      planId = String(window.ngBuyBoxPrepareForAddToCart(formEl) || '').trim();
    } else {
      formEl.dispatchEvent(new CustomEvent('ng:before-add-to-cart'));
    }
    if (!planId) {
      planId = String(window.ngBuyBoxGetSellingPlan(formEl) || '').trim();
    }
    return planId;
  };

  function patchBuyboxCartAddFetch() {
    if (window.__mpbV21CartAddFetchPatched) return;
    window.__mpbV21CartAddFetchPatched = true;
    var nativeFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (url.indexOf('/cart/add') === -1 || !init || !init.body || typeof init.body !== 'string') {
        return nativeFetch(input, init);
      }
      try {
        var payload = JSON.parse(init.body);
        if (!payload.items || !payload.items[0] || payload.items[0].selling_plan) {
          return nativeFetch(input, init);
        }
        var form = document.querySelector('.mpb-v21__form');
        if (!form || typeof window.mpbV21ResolveCartLine !== 'function') {
          return nativeFetch(input, init);
        }
        var line = window.mpbV21ResolveCartLine(form);
        if (!line || !line.selling_plan) {
          return nativeFetch(input, init);
        }
        payload.items[0].id = Number(line.id);
        payload.items[0].quantity = line.quantity;
        payload.items[0].selling_plan = Number(line.selling_plan);
        init = Object.assign({}, init, { body: JSON.stringify(payload) });
        if (typeof input !== 'string' && input instanceof Request) {
          input = new Request(input, init);
          init = undefined;
        }
      } catch (e) { /* noop */ }
      return nativeFetch(input, init);
    };
  }

  function initAll() {
    patchBuyboxCartAddFetch();
    document.querySelectorAll('.mpb-v21').forEach(initBuyBox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Theme editor re-render support
  document.addEventListener('shopify:section:load', initAll);
})();
